export function flattenObject(obj: any, prefix: string = ''): { [key: string]: any } {
  let flattened: { [key: string]: any } = {}

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const prop = obj[key]

      if (typeof prop === 'object' && prop !== null && !Array.isArray(prop)) {
        const nested = flattenObject(prop, `${prefix}${key}.`)
        flattened = { ...flattened, ...nested }
      } else {
        flattened[`${prefix}${key}`] = prop
      }
    }
  }

  return flattened
}
